import { Pill } from '@endaoment-frontend/ui/shared';

import styles from './OTCHero.module.scss';

export const OTCHero = () => {
  return (
    <section className={styles['otc-hero']}>
      <Pill size="large" variation="blue">
        Donate Over-the-Counter
      </Pill>
      <h1>OTC Donations</h1>
      <h2>
        Looking to make a donation to an Endaoment fund “Over-the-Counter”?
        <br />
        Please send assets to the corresponding address for your token and fill out an OTC form.
      </h2>
    </section>
  );
};
